import type { EnrollmentCreateRequestEnrollmentType } from './enrollmentCreateRequestEnrollmentType';

export interface EnrollmentCreateRequest {
  /** 강좌 ID */
  courseId: string;
  /** 수강신청 유형 */
  enrollmentType?: EnrollmentCreateRequestEnrollmentType;
  /** 학생 ID */
  studentId: string;
}
